export default __webpack_public_path__ + "assets/x-logo.c9d69acf.png";